import React from 'react';
import Leaderboard from './Leaderboard';
import { PropsFromScreenManager } from '../../types';
import Screen from '../../Screen';

class LeaderboardScreen extends Screen {
  constructor(props: PropsFromScreenManager) {
    super(props);
  }

  render() {
    return <Leaderboard/>;
  }
}

export default LeaderboardScreen;
